import { useState } from 'react';
import { deleteApplication } from '../../api/client.js';
import { useAppStore } from '../../store/useAppStore.js';
import { useToastStore } from '../../store/useToastStore.js';
import { Modal } from '../common/Modal.jsx';

export function DeleteConfirmDialog({ app, onClose }) {
  const removeApplicationLocal = useAppStore((s) => s.removeApplicationLocal);
  const addToast = useToastStore((s) => s.addToast);
  const [deleting, setDeleting] = useState(false);

  async function handleDelete() {
    setDeleting(true);
    try {
      await deleteApplication(app.appId);
      removeApplicationLocal(app.appId);
      onClose();
      addToast('Deleted ✓', 'success');
    } catch {
      setDeleting(false);
    }
  }

  return (
    <Modal onClose={onClose} className="max-w-sm">
      <div className="p-6 space-y-4">
        <h2 className="text-base font-semibold text-slate-900">Delete Permanently</h2>
        <p className="text-sm text-slate-600">
          This action is irreversible. The application for <span className="font-medium">{app.company} — {app.role}</span> and all associated data will be permanently removed.
        </p>
        <div className="flex justify-end gap-2">
          <button onClick={onClose} className="rounded px-3 py-1.5 text-sm text-slate-600 hover:bg-slate-100">Cancel</button>
          <button
            onClick={handleDelete}
            disabled={deleting}
            className="rounded bg-destructive-600 px-4 py-1.5 text-sm font-medium text-white hover:bg-destructive-700 disabled:opacity-50"
          >
            {deleting ? 'Deleting…' : 'Delete'}
          </button>
        </div>
      </div>
    </Modal>
  );
}
